<mat-toolbar class="p-0 {{labelRol}}">

    <mat-progress-bar *ngIf="showLoadingBar" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>
  
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
  
      <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
  
        <button mat-button class="toggle-button-navbar mat-icon-button"
                appNavbar="toggleBar" fxHide.gt-md *ngIf="isAuthenticated">
          <mat-icon class="icon-menu">menu</mat-icon>
        </button>
  
        <button mat-button class="toggle-button-navbar mat-icon-button"
                appNavbar="toggleFold" fxHide fxShow.lg fxShow.xl *ngIf="isAuthenticated">
          <mat-icon class="icon-menu">menu</mat-icon>
        </button>
  
        <!--<div class="toolbar-separator" fxHide.gt-md></div>-->
  
      </div>
  
      <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
  
        <button mat-button
          *ngIf="isAuthenticated"
          class="quick-panel-toggle-button mat-icon-button"
          [ngClass]="{'admin': labelRol == 'Administrador'}"
          appMatSidenavToggler="quick-panel">
          <mat-icon *ngIf="alertsCounts > 0"
                    class="icon-notification">
                    <span class="baged"></span>
            notifications
          </mat-icon>
          <mat-icon *ngIf="alertsCounts == 0"
                    class="icon-notification">
            notifications
          </mat-icon>
        </button>
  
        <div class="ctn-account mr-24 ml-24" fxLayout="row" fxLayoutAlign="center center">
          <div class="info mr-12">
            <p *ngIf="!isAuthenticated" style="cursor: pointer;" [routerLink]="['/auth']">Iniciar Sesión</p>
            <p *ngIf="isAuthenticated">{{ rolname }}</p>
            <p fxHide fxShow.gt-sm>{{ username }}</p>
          </div>
          <div class="icon" *ngIf="!twoToken">
            <img *ngIf="labelRol != 'Administrador'" src="assets/images/icons/icon-avatar-duck.svg" alt="avatar">
            <img *ngIf="labelRol == 'Administrador'" src="assets/images/icons/admin/icon-avatar-duck.svg" alt="avatar">
          </div>
          <div class="icon flip-card" *ngIf="twoToken" (click)="changeToken()">
            <div class="card-inner">
              <div class="card-front">
                <img src="assets/images/icons/icon-avatar-duck.svg" alt="avatar">
              </div>
              <div class="card-back">
                <img src="assets/images/icons/admin/icon-avatar-duck.svg" alt="avatar">
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </mat-toolbar>
  